import { Field, NativeComponents, Fieldset } from '../FormSchema.esm.min.js'
import ExtensionChoseMedium from './ExtensionChoseMedium'

const CreateInput = (h, tag, data, children = [], event = 'input') => {
  if (data.key.includes('medium')) {
    return CreateAutocompleteInput(h, tag, data, children, event)
  }

  const props = data.props
  // console.info('CreateInput', tag, data, children)
  return h(tag, {
    key: props.field.key,
    // value: props.field.attrs.value,
    attrs: {
      ...data.attrs
      // value: data.attrs.value
    },
    on: {
      [event] (value) {
        props.field.setValue(value)
      }
    }
  }, children)
}

const CreateAutocompleteInput = (h, tag, data, children = [], event = 'input') => {
  const props = data.props
  return h(ExtensionChoseMedium, {
    key: props.field.key,
    attrs: {
      ...data.attrs
    },
    on: {
      [event] (value) {
        props.field.setValue(value)
      }
    }
  }, children)
}

const HelperElement = {
  name: 'HelperElement',
  functional: true,
  render (h, { props }) {
    const field = props.field
    const descriptor = props.field.descriptor

    if (descriptor.helper) {
      const tag = field.isRoot ? 'p' : 'span'
      const data = {
        attrs: Object.assign(Object.assign({}, descriptor.helperAttrs), { 'data-fs-helper': true })
      }
      return h(tag, data, descriptor.helper)
    }
    return null // render nothing
  }
}

const FieldElement = {
  name: 'FieldElement',
  functional: true,
  render (h, { data, props, children }) {
    const field = props.field

    if (field.kind === 'hidden') {
      return children
    }
    const descriptor = props.field

    // const type = field.attrs.type || field.kind
    const nodes = [...children]
    const helperNode = h(HelperElement, data)
    if (helperNode.tag) {
      nodes.push(helperNode)
    }
    Field.renderMessages(h, descriptor, nodes)

    if (field.kind === 'object') {
      const header = descriptor.schema.title ? h('h1', {}, descriptor.schema.title) : null
      return h('div', {
      }, [
        header,
        ...nodes
      ])
    } else {
      return h('el-form-item', {
        attrs: {
          ...descriptor.labelAttrs,
          label: descriptor.schema.title
        }
      }, nodes)
    }
  }
}

const FieldsetElement = {
  name: 'FieldsetElement',
  functional: true,
  render (h, { data, props, slots }) {
    const descriptor = props.field.descriptor
    const nodes = descriptor.kind === 'object' && Object.keys(descriptor.groups).length > 0
      ? Fieldset.renderGroups(h, descriptor)
      : slots().default || Fieldset.renderChildren(h, descriptor, props.field.children)
    if (!props.field.isRoot) {
      return h(FieldElement, data, nodes)
    }
    const attrs = Object.assign(Object.assign({}, props.field.attrs), (data.attrs || {}))
    const helper = h(HelperElement, data)
    if (helper.tag) {
      nodes.unshift(helper)
    }
    if (descriptor.label) {
      const attrs = descriptor.labelAttrs
      const legend = h('legend', { attrs }, descriptor.label)
      nodes.unshift(legend)
    }
    Field.renderMessages(h, props.field, nodes, props.field.isRoot)
    return h('div', { attrs }, nodes)
  }
}

const InputElement = {
  name: 'InputElement',
  functional: true,
  render (h, { data, children }) {
    return h(FieldElement, data, [
      CreateInput(h, 'el-input', data),
      ...(children || [])
    ])
  }
}

const FormElement = {
  name: 'FormElement',
  functional: true,
  render (h, { data, children }) {
    data.key = data.attrs.id
    return h('el-form', {
      ...data,
      attrs: {
        ...data.attrs,
        labelWidth: '140px'
      }
    }, children)
  }
}

const ArrayButtonElement = {
  functional: true,
  name: 'ArrayButtonElement',
  render (h, { props: { button, field, descriptor } }) {
    return h('el-button', {
      attrs: {
        type: 'info',
        title: button.tooltip,
        disabled: button.disabled,
        size: 'mini'
      },
      on: {
        click: button.trigger
      }
    }, button.label)
  }
}

const StateElement = {
  name: 'StateElement',
  functional: true,
  render (h, { data, props: { field }, children = [] }) {
    return h(FieldElement, data, [
      h('el-checkbox', {
        key: field.key,
        attrs: {
          ...field.attrs,
          value: field.attrs.checked,
          style: 'padding: 0 10px' // FIXME
        },
        on: {
          change: (value) => field.setValue(value)
        }
      }),
      ...children
    ])
  }
}

export class FormSchemaElementUI extends NativeComponents {
  constructor () {
    super()
    this.set('form', FormElement)
    this.set('enum', FieldsetElement)
    this.set('object', FieldsetElement)
    this.set('string', InputElement)
    this.set('password', InputElement)
    this.set('boolean', StateElement)
    this.set('number', InputElement)
    this.set('integer', InputElement)
    this.set('button', ArrayButtonElement)
  }
}



// WEBPACK FOOTER //
// ./src/components/FormSchemaElementUI.js